import { Label } from '@fz/ui-components-react';
import type { ReactElement } from 'react';

interface WebSessionActionPopupContentProps {
  heading: string | null;
}

export const WebSessionActionPopupContent = ({
  heading = '',
}: WebSessionActionPopupContentProps): ReactElement => {
  return (
    <div className="web-session-action-popup__panel">
      <Label as={'span'} className="body2" fontWeightStyle="regular">
        {heading}
      </Label>
    </div>
  );
};
